import { loc } from "../i18n/survey";

enum Injuries {
  Shoulder = 'Shoulder',
  Elbow = 'Elbow',
  LowerBack = 'Lower Back',
  Knee = 'Knee',
  Other = 'Other',
  special ='special',
}

const injuriesQuestion = {
  name: 'injuries',
  title: loc("quiz.injuries.title"),
  description: loc("quiz.injuries.description"),
  descriptionLocation: 'underTitle',
  type: 'checkbox',
  choices: [
    {
      value: Injuries.Shoulder,
      text: loc("quiz.injuries.choices.shoulder"),
    },
    {
      value: Injuries.Elbow,
      text: loc("quiz.injuries.choices.elbow"),
    },
    {
      value: Injuries.LowerBack,
      text: loc("quiz.injuries.choices.lowerBack"),
    },
    {
      value: Injuries.Knee,
      text: loc("quiz.injuries.choices.knee"),
    },
    {
      value: Injuries.Other,
      text: loc("quiz.injuries.choices.other"),
    },
      {
      value: Injuries.special,
      text: 'special',
      visibleIf: "false",
      hidden: true, // Mark as hidden
    },
  ],
  // showOtherItem: true,
  showNoneItem: true,
  // "None" agrees with a feminine noun in Spanish (lesión, restricción, opción).
  noneText: loc("quiz.shared.noneFeminine"),
  isRequired: true,
};

export {
  Injuries,
  injuriesQuestion,
}